module.exports = __webpack_public_path__ + "img/pencil-edit.97473195.svg";